<template>
	<div id="katalog-tiket-form">
    <!-- begin breadcrumb -->
		<ol class="breadcrumb pull-right">
      <li>
        <router-link :to="{path: '/'}">Home</router-link>
      </li>
      <li>Pembayaran</li>
      <li>
        <router-link :to="{path: '/katalog-tiket'}">List Katalog Tiket</router-link>
      </li>
      <li class="active">{{ !$route.query.id ? 'Buat' : 'Update' }} Katalog Tiket</li>
    </ol>
    <!-- end breadcrumb -->
    <!-- begin page-header -->
    <h1 class="page-header">{{ !$route.query.id ? 'Buat' : 'Update' }} Katalog Tiket</h1>
    <!-- end page-header -->
		<div class="row">
      <div class="col-md-12">
        <div class="panel panel-inverse">
          <div class="panel-heading">
            <h4 class="panel-title">{{ !$route.query.id ? 'Buat' : 'Update' }} Katalog Tiket</h4>
          </div>
          <div class="panel-body">
			<div class="alert alert-danger fade in m-b-15" v-if="this.errors.length > 0">
              <span class="close" data-dismiss="alert">&times;</span>
              <strong>Terjadi kesalahan!</strong>
              <ul>
                <li v-for="(message, key) in this.errors" v-bind:key="key">{{message}}</li>
              </ul>
            </div>

						<!-- begin form -->
            <form>
              <div class="form-horizontal form-bordered">
                <div class="form-group">
                  <label class="col-md-2 control-label">Tipe</label>
                  <div class="col-md-8 col-xs-12">
										<select class="form-control" v-model="data.type">
											<option value="">-- Pilih Tipe Katalog --</option>
											<option 
												v-for="katalogType in types" 
												:key="katalogType.key" 
												:value="katalogType.key"
											>
												{{ katalogType.title }}
											</option>
										</select>
									</div>
                </div>

								<div v-if="data.type">
									<div class="form-group">
										<label class="col-md-2 control-label">Title</label>
										<div class="col-md-8 col-xs-12">
											<input type="text" class="form-control" v-model="data.title">
										</div>
									</div>

									<div 
										class="form-group" 
										v-for="katalogType in types" 
										v-if="data.type === katalogType.key && katalogType.key !== 'DUEL' && katalogType.key !== 'CONSULTATION' && katalogType.key !== 'SCHEDULED_TRYOUT'"
										:key="katalogType.key"
									>
										<label class="col-md-2 control-label">
											{{katalogType.value}}
										</label>
										<div class="col-md-8 col-xs-12">
											<vue-numeric separator="." class="form-control" v-model="data.value" />
										</div>
									</div>
									
									<div class="form-group" v-if="data.type === 'SCHEDULED_TRYOUT'">
										<label class="col-md-2 control-label">Apakah Langganan ?</label>
										<div class="col-md-8 col-xs-12">
											<!-- <vue-numeric separator="." class="form-control" v-model="data.value" /> -->
											<input type="checkbox" v-model="data.is_subscription"/>
										</div>
									</div>
									
									<div class="form-group" v-if="data.type === 'SCHEDULED_TRYOUT' && data.is_subscription">
										<label class="col-md-2 control-label">Bulan</label>
										<div class="col-md-8 col-xs-12">
											<vue-numeric separator="." class="form-control" v-model="data.value" />
										</div>
									</div>

									<div class="form-group">
										<label class="col-md-2 control-label">Tiket</label>
										<div class="col-md-8 col-xs-12">
											<vue-numeric separator="." class="form-control" v-model="data.ticket" />
										</div>
									</div>

									<div class="form-group">
										<label class="col-md-2 control-label">Deskripsi</label>
										<div class="col-md-8 col-xs-12">
											<ckeditor :editor="editor" v-model="data.description" :config="editorConfig"></ckeditor>
											<br />
											<span v-if="data.description"><i>({{characterCounter(data.description)}} karakter)</i></span>
										</div>
									</div>

									<div class="form-group">
										<label class="col-md-2 control-label">Gambar<br />(Max 1MB)</label>
										<div class="col-md-8 col-xs-12">
											<div class="row">
												<div class="col-md-4" v-if="data.picture">
													<img class="img-fluid" :src="data.picture" />
												</div>
												<div class="col-md-8">
													<input type="file" class="form-control" accept="image/*" @change="handleChangePicture($event)" />
												</div>
											</div>
										</div>
									</div>

									<div class="form-group">
										<label class="col-md-2 control-label">Status</label>
										<div class="col-md-8 col-xs-12">
											<select class="form-control" v-model="data.status">
												<option value="">-- Pilih Status --</option>
												<option :value="status.PUBLISH">Publish</option>
												<option :value="status.UNPUBLISH">Unpublish</option>
											</select>
										</div>
									</div>
								</div>
              </div>
            </form>
						<hr />
            <div class="pull-right">
              <button v-if="!$route.query.id && !$route.query.liveId" type="button" class="btn btn-success pull-right" @click="saveData()">Simpan</button>
              <button v-else type="button" class="btn btn-success pull-right" @click="editData()">Update</button>
            </div>
          </div>
        </div>
      </div>
		</div>
		<app-spinner v-if="isLoading"></app-spinner>
	</div>
</template>

<script>
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import SalesService from '@/services/sales.js'
import Spinner from '@/components/plugins/Spinner'

export default {
	name: 'katalog-tiket-form',
	components: {
		'app-spinner': Spinner,
	},
	data: function () {
		return {
			errors: [],
			queryId: null,
			isLoading: false,
			status: {
				PUBLISH: 'PUBLISHED',
				UNPUBLISH: 'UNPUBLISHED'
			},
			types: [
				{
					key: 'SCHEDULED_TRYOUT',
					title: 'SCHEDULED TRYOUT',
					value: 'Jumlah TO'
				},
				{
					key: 'INSTANT_TRYOUT',
					title: 'INSTANT TRYOUT',
					value: 'Bulan'
				},
				{
					key: 'CONSULTATION',
					title: 'CONSULTATION',
					value: 'Jumlah'
				},
				{
					key: 'DUEL',
					title: 'DUEL',
					value: null
				},
				{
					key: 'ITEM_BANK',
					title: 'ITEM BANK',
					value: 'Bulan'
				},
				{
					key: 'VIDEO',
					title: 'VIDEO',
					value: 'Bulan'
				}
			],
			selectedPicture: null,
			data: {
				type: "",
				title: null,
				value: null,
				description: null,
				ticket: null,
				picture: null,
				status: null,
				is_subscription: true
			},
			editor: ClassicEditor,
			editorConfig: {
				toolbar: ['heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', 'blockQuote', '|', 'outdent', 'indent'],
			}
		}
	},
	mounted: function () {
		if (this.$route.query.id) {
			this.queryId = this.$route.query.id
			this.fetchData()
		}
	},
	methods: {
		fetchData: function () {
			var context = this
			var queryId = this.queryId
			this.isLoading = true

			SalesService.getKatalogTiketDetail(queryId, function (result) {
				context.isLoading = false
				if (result.success) {
					context.data.title = result.data.title
					context.data.type = result.data.type
					context.data.ticket = result.data.ticket
					context.data.value = result.data.value
					context.data.picture = result.data.picture
					context.data.description = result.data.description
					context.data.status = result.data.status
					context.data.is_subscription = result.data.is_subscription
				} else {
					alert('Terjadi Kesalahan : ' + result.message)
				}
			})
		},
		saveData: function () {
			var context = this
			var data = this.data
			this.isLoading = true
			if(this.data.type === 'DUEL' || this.data.type === 'CONSULTATION'){
				this.data.is_subscription = false
				this.data.value = 1
			} else if (this.data.type === 'INSTANT_TRYOUT' || this.data.type === 'VIDEO' || this.data.type === 'ITEM_BANK'){
				this.data.is_subscription = true
			}else if(this.data.type === 'SCHEDULED_TRYOUT' && this.data.is_subscription === false ){
				this.data.value = 1
			}
			if (this.validateForm()) {
				SalesService.addKatalogTiket(data, function (result) {
					context.isLoading = false
					if (result.success) context.doUploadPicture(result.data.id)
					else alert('Terjadi Kesalahan : ' + result.message)
				})
			} else {
				this.isLoading = false
				$(window).scrollTop(0)
			}
		},
		editData: function () {
			var context = this
			var id = this.queryId
			var data = this.data
			this.isLoading = true
			if(this.data.type === 'DUEL' || this.data.type === 'CONSULTATION'){
				this.data.is_subscription = false
				this.data.value = 1
			} else if (this.data.type === 'INSTANT_TRYOUT' || this.data.type === 'VIDEO' || this.data.type === 'ITEM_BANK'){
				this.data.is_subscription = true
			}else if(this.data.type === 'SCHEDULED_TRYOUT' && this.data.is_subscription === false ){
				this.data.value = 1
			}
			if (this.validateForm()) {
				SalesService.updateKatalogTiket(id, data, function (result) {
					context.isLoading = false
					if (result.success) context.doUploadPicture(id)
					else alert('Terjadi Kesalahan : ' + result.message)
				})
			} else {
				this.isLoading = false
				$(window).scrollTop(0)
			}
		},
		validateForm: function () {
			this.errors = []
			if (!this.data.type) {
				this.errors.push('Tipe produk wajib diisi')
			} else {
				if (!this.data.title) this.errors.push('Judul wajib diisi')

				// if value is null and type !== DUEL
				if (!this.data.value && this.data.type !== this.types[3].key && this.data.type !== this.types[2].key && this.data.type !== this.types[0].key) {
					this.types.map((type, index) => {
						if (this.data.type === type.key) this.errors.push(`${type.value} wajib diisi`)
					})
				}
				if (!this.data.picture) this.errors.push('Gambar wajib diisi')
				if (!this.data.description) this.errors.push('Deskripsi wajib diisi')
				if (this.data.description) {
					if (this.characterCounter(this.data.description) > 1000) {
						this.errors.push('Deskripsi tidak boleh lebih dari 1000 karakter')
					}
				}
				if (!this.data.ticket) this.errors.push('Ticket wajib diisi')
				if (!this.data.status) this.errors.push('Status wajib diisi')
				if (this.selectedPicture) {
					if (this.selectedPicture.size > 1000000) this.errors.push('Gambar tidak boleh lebih dari 1MB')
				}
			}
			return this.errors.length == 0
		},
		handleChangePicture: function (event) {
			const file = event.target.files[0]
			this.selectedPicture = file
			this.data.picture = URL.createObjectURL(file);
		},
		characterCounter: function (text) {
			text = text.replace(/<[^>]*>/g, '')
			text = text.replace(/\&nbsp;/g, ' ')
			return text.length
		},
		doUploadPicture: function (id) {
			var context = this
			var picture = this.selectedPicture
			var formData = new FormData()

			if (picture) {
				formData.append('name', picture.name)
				formData.append('file', picture)

				SalesService.uploadKatalogTiketPicture(id, formData, function (result) {
					context.isLoading = false
					if (result.success) context.$router.push({ path: '/katalog-tiket' })
					else alert('Gagal Upload Picture')
				})
			} else {
				context.$router.push({ path: '/katalog-tiket' })
			}
		}
	}
}
</script>

<style>
.ck-content {
  min-height: 120px;
}
</style>



// WEBPACK FOOTER //
// KatalogTiketForm.vue?3ebc211a